import React from 'react';
import ReactDOM from 'react-dom/client';
import KannavisCare from './KannavisCare';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <KannavisCare />
  </React.StrictMode>
);
